import IconGearsSolid from '@/assets/icons/font_awesome/gears-solid.svg?react';
import IconGift from '@/assets/icons/lucide/gift.svg?react';
import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_slice_user } from '@/hooks/store/use_slices';
import i18n_base_ui from '@/locales/keys/i18n_base_ui.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { ENUM__user_role } from '@shared/dto/+user/entity/ENUM__user_role';
import { EShortcutType } from '@shared/dto/hint_shortcuts/e_shortcut_type';
import { useTranslation } from 'react-i18next';
import { ViewShortcutTrigger } from '../../shortcut_hint/ViewShortcutTrigger';
import { DropdownWorkspaceAvatar } from '../../views/workspace/DropdownWorkspaceAvatar';
import { ButtonNavigationModels } from '../button_wrappers/ButtonNavigationModels';
import { ButtonNavigationOpenPose } from '../button_wrappers/ButtonNavigationOpenPose';
import { ButtonNavigationSearch } from '../button_wrappers/ButtonNavigationSearch';
import { BUTTON__navigation_desktop } from './BUTTON__navigation_desktop';

export function SidebarNavigationDesktop() {
  const { t } = useTranslation(ENUM__i18n_namespace.BASE_UI);

  const { is_authorized, user_role, user_settings } = use_slice_user(['is_authorized', 'user_role', 'user_settings']);
  /*
   * RENDERS
   */

  function render_button_admin() {
    if (!is_authorized) return <></>;
    if (user_role != ENUM__user_role.ADMIN) return <></>;

    return (
      <>
        <BUTTON__navigation_desktop
          page_type={ENUM__page_type.ADMIN}
          title={t(i18n_base_ui.sidebar_navigation.tabs.admin.title)}
          tooltip_title={t(i18n_base_ui.sidebar_navigation.tabs.admin.tooltip.title)}
          Icon={IconGearsSolid}
        />
        <BUTTON__navigation_desktop
          page_type={ENUM__page_type.RESERVATIONS_WITHOUT_PARAMS}
          title={'Reservations'}
          tooltip_title={'Reservations'}
          Icon={IconGift}
        />
      </>
    );
  }

  /*
   * HTML
   */

  return (
    <div className={`w-[70px] min-w-[70px] h-full flex flex-col justify-between items-center py-5 bg-bar border-r border-component-border`}>
      <div className="w-full bg-bar  flex flex-col  justify-start gap-0 items-center">
        <DropdownWorkspaceAvatar />

        <ViewShortcutTrigger hint_shortcut_keys={[EShortcutType.NAVIGATION_HOTKEYS_BETWEEN_PAGES]}>
          <ButtonNavigationSearch />
          <ButtonNavigationModels />
          <ButtonNavigationOpenPose />

          {render_button_admin()}
        </ViewShortcutTrigger>
      </div>

      <div className="flex flex-col gap-1 items-center">{}</div>
    </div>
  );
}
